import { render } from "./AdminPageLayout.vue?vue&type=template&id=75ad7ff5&scoped=true"
const script = {}

import "./AdminPageLayout.vue?vue&type=style&index=0&id=75ad7ff5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ad7ff5"]])

export default __exports__